(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["btm_site_recipes"] = factory();
	else
		root["btm_site_recipes"] = factory();
})(globalThis, () => {
return 